module.exports = "/wwwroot/img/water_supply_link_list_block.png?ver=23204d1c";